import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {frefFromRef} from '../../../lib/react/higher-order-components';
import {OEDefaultConfigFactory} from '../../oe-default-configs';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OENavigationViewComponent} from '../../../lib/components/oe-navigation-controller';
import {OEFNStartSelectionContentFactory} from '../flow-nav/start-selection/oe-fn-start-selection-model';
import OEFlowNavModal from '../flow-nav/oe-flow-nav-modal';
import OEFlowNavStartSelectionView from '../flow-nav/start-selection/oe-flow-nav-start-selection-view';

export class OEStartSelectionViewStd extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.state = {
            options: clone(this.props.options)
        };

        this.onOptionsChanged = this.onOptionsChanged.bind(this);

        this.onRef = this.onRef.bind(this);

        this.onStartSelectionItemClick = this.onStartSelectionItemClick.bind(this);
    }

    onRef(ref)  {
        this.ref = ref;
        if(this.props.fref) this.props.fref(ref);
    }

    onOptionsChanged(sender, options)   {
        this.setState({options: clone(options)})
    }

    render() {
        let {logo, ...configRest} = this.props.config;

        logo = this.props.logo;
        let config = Object.assign({}, configRest);

        if(this.state.options)  {
            if(typeof(this.state.options.logo) === 'string')    logo = this.state.options.logo;
            if(this.state.options.config && typeof(this.state.options.config) === 'object')    config = Object.assign(config, this.state.options.config);
            if(OEFNStartSelectionContentFactory.isContent(this.state.options.content))    config.content = this.state.options.content;
        }

        return (
            <OEFlowNavModal
                moduleId={this.props.moduleId}
                className={'start-view start-selection-view ' + this.props.className}
                config={config.showLogo && logo ? {logo: logo} : null}
                isOpen={this.props.isOpen}
                onOpenStateChanged={this.props.onOpenStateChanged}
                onOptionsChanged={this.onOptionsChanged}
                ref={this.onRef}
            >
                <OENavigationViewComponent
                    title={{titleId: 'welcome_view_start_selection', icon: OEIconCodes.startSelection}}
                >
                    <OEFlowNavStartSelectionView
                        moduleId={this.props.moduleId}
                        locStringPrefix={this.props.locStringPrefix}
                        {...config}
                        onItemClick={this.onStartSelectionItemClick}
                    />
                </OENavigationViewComponent>
            </OEFlowNavModal>
        );
    }

    onStartSelectionItemClick(sender, item, changeTarget) {
        if(this.ref && changeTarget)    this.ref.close();
    }
}

OEStartSelectionViewStd.defaultProps = {
    moduleId: '',
    className: '',
    config: OEDefaultConfigFactory.startSelection()
};

OEStartSelectionViewStd.propTypes = {
    moduleId: PropTypes.string,
    className: PropTypes.string,
    logo: PropTypes.string,
    isOpen: PropTypes.bool,
    config: OEDefaultConfigFactory.startSelectionDecl,
    onOpenStateChanged: PropTypes.func
};

export default frefFromRef(OEStartSelectionViewStd);